import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

// Catch-all for unmatched routes.
//
// React Router renders nothing when no route matches, which is how a single
// missing route (/payment-success) produced a blank white page immediately
// after a successful payment, with nothing on screen to act on. Any future
// mismatch now surfaces as a page with a way out rather than silence.
const NotFound = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-md p-6 text-center">
        <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-gray-100">
          <svg className="h-6 w-6 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
              d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <h2 className="mt-4 text-xl font-semibold text-gray-900">Page not found</h2>
        <p className="mt-2 text-gray-600">
          We couldn't find <span className="font-mono text-sm break-all">{location.pathname}</span>.
        </p>
        <p className="mt-2 text-sm text-gray-500">
          If you were completing a payment, it may still have gone through — check your dashboard
          before trying again.
        </p>

        <div className="mt-6 space-y-3">
          <button
            onClick={() => navigate('/dashboard')}
            className="w-full bg-[#101418] text-white py-3 px-4 rounded-lg font-medium hover:bg-[#2c3540] transition-colors"
          >
            Go to Dashboard
          </button>
          <button
            onClick={() => navigate('/')}
            className="w-full bg-gray-100 text-gray-800 py-3 px-4 rounded-lg font-medium hover:bg-gray-200 transition-colors"
          >
            Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
